import React from 'react'
import { MDBDatepicker } from 'mdb-react-ui-kit'
import moment from 'moment'

const DEFAULT_FORMAT = 'MM/DD/YYYY'

const toMomentFormat = format =>
  `${format || DEFAULT_FORMAT}`
    .replace(/mmmm/g, 'MMMM')
    .replace(/mmm/g, 'MMM')
    .replace(/mm/g, 'MM')
    .replace(/dd/g, 'DD')
    .replace(/yyyy/g, 'YYYY')
    .replace(/yy/g, 'YY')

const toDatepickerFormat = format =>
  toMomentFormat(format)
    .replace(/MMMM/g, 'mmmm')
    .replace(/MMM/g, 'mmm')
    .replace(/MM/g, 'mm')
    .replace(/DD/g, 'dd')
    .replace(/YYYY/g, 'yyyy')
    .replace(/YY/g, 'yy')

const MDB4DatePicker = ({ value, format, getValue, onChange, maxDate, minDate, emptyLabel, ...rest }) => {
  const momentFormat = toMomentFormat(format)
  const parsed = value ? moment(value) : null
  const displayValue = parsed && parsed.isValid() ? parsed.format(momentFormat) : ''

  const handleChange = (nextValue, nextDate) => {
    if (`${nextValue || ''}` === displayValue) return

    const parsedNext = nextValue ? moment(nextValue, momentFormat, true) : null
    if (nextValue && !parsedNext.isValid()) return

    const date = parsedNext ? parsedNext.toDate() : nextDate instanceof Date ? nextDate : null

    if (typeof getValue === 'function') getValue(date)
    if (typeof onChange === 'function') onChange(date)
  }

  return (
    <MDBDatepicker
      {...rest}
      format={toDatepickerFormat(format)}
      value={displayValue}
      {...(maxDate ? { max: maxDate } : {})}
      {...(minDate ? { min: minDate } : {})}
      onChange={handleChange}
    />
  )
}

export default MDB4DatePicker
